var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0147 0C6.02078 0 2.77148 3.2493 2.77148 7.2432C2.77148 12.1998 9.25348 19.4763 9.52945 19.7836C9.78867 20.0723 10.2413 20.0718 10.5 19.7836C10.776 19.4763 17.258 12.1998 17.258 7.2432C17.2579 3.2493 14.0086 0 10.0147 0ZM10.0147 18.3488C7.8332 15.7575 4.07586 10.645 4.07586 7.24328C4.07586 3.96852 6.74 1.30438 10.0147 1.30438C13.2895 1.30438 15.9536 3.96852 15.9536 7.24324C15.9536 10.6451 12.1968 15.7566 10.0147 18.3488Z",
    fill: "#ABAFB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0153 3.59912C8.00586 3.59912 6.37109 5.23393 6.37109 7.24338C6.37109 9.25283 8.0059 10.8876 10.0153 10.8876C12.0247 10.8876 13.6595 9.25283 13.6595 7.24338C13.6595 5.23393 12.0247 3.59912 10.0153 3.59912ZM10.0153 9.58326C8.72508 9.58326 7.67547 8.53361 7.67547 7.24338C7.67547 5.95314 8.72512 4.9035 10.0153 4.9035C11.3055 4.9035 12.3552 5.95314 12.3552 7.24338C12.3552 8.53361 11.3055 9.58326 10.0153 9.58326Z",
    fill: "#ABAFB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.73a9986d902bb040a2a62a8614f78e9b.svg";
export { ForwardRef as ReactComponent };